import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DS_DEMO_DNA2_END = {
  title:
    "Find out more about Infosys Data\nOperations Streams demo from \nour staff. ",
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage(201),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage(205),
      startIcon: "arrow-right",
    },
  ],
};
